"use strict";

jQuery(document).ready(function ($) {
  var currentPage = $('.ajax_row_holder').find('.page-numbers.current').text();
  localStorage.setItem('currentPage', currentPage);
  var ResizePagination = false;
  function ChangeMobilePagination() {
    var mobilePagination = $('.ajax_row_holder').find('.page-numbers.current'),
      currentPage = mobilePagination.text(),
      maxPages = $('.ajax_row').attr('data-max-pages');
    localStorage.setItem('currentPage', currentPage);
    mobilePagination.text('Page ' + currentPage + ' of ' + maxPages);
  }
  if ($(window).width() < 768) {
    ChangeMobilePagination();
    ResizePagination = true;
  }
  $(window).on('resize', function () {
    if ($(window).width() < 768) {
      if (ResizePagination === false) {
        ChangeMobilePagination();
        ResizePagination = true;
      }
    } else {
      ResizePagination = false;
      $('.ajax_row_holder').find('.page-numbers.current').text(localStorage.getItem('currentPage'));
    }
  });
  $(document).on('AjaxPaginationDone', function () {
    var currentPage = $('.ajax_row_holder').find('.page-numbers.current').text();
    localStorage.setItem('currentPage', currentPage);
    if ($(window).width() < 768) {
      ChangeMobilePagination();
      ResizePagination = true;
    }
  });
});